    document.addEventListener("DOMContentLoaded",
            function () {
                var div, n,
                        v = document.getElementsByClassName("youtube-player");
                for (n = 0; n < v.length; n++) {
                    div = document.createElement("div");
                    console.log(v[n].dataset.id);
                    console.log(v[n].dataset);
                    console.log(v[n]);
                    div.setAttribute("data-id", v[n].dataset.id);
                    div.innerHTML = labnolThumb("https://img.youtube.com/vi/" + v[n].dataset.id + "/hqdefault.jpg");
                    console.log(v[n].dataset.image);
                    div.onclick = labnolIframe;
                    v[n].appendChild(div);
                }
            });

    function labnolThumb(img) {
        var thumb = '<img loading="lazy" src="IMGURL">',
                play = '<div class="oe-modal__button-play play"></div>';
        return thumb.replace("IMGURL", img) + play;
    }

    function labnolIframe() {
        var iframe = document.createElement("iframe");
        var embed = "https://www.youtube.com/embed/ID?autoplay=1&version=3&enablejsapi=1";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        iframe.setAttribute("id", "youtube-video");
        this.parentNode.replaceChild(iframe, this);
    }

    function myClose() {
        var elms = document.querySelectorAll("[id='youtube-video']");

        for (var i = 0; i < elms.length; i++) {
            elms[i].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        }
    }